import { NaniumObject, RequestType, Type } from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';
import { NextOffer } from '../../entities/nextOffer.entity';
import { GeoLocationType } from '../../entities/types/geoLocation.type';

// Radius filter/sort center for the find-offer search. radius in km; without
// it the center only sorts (home sliders: nearest offers, no cutoff).
export class NextOfferLocationFilterType extends NaniumObject<NextOfferLocationFilterType> {
	@Type(Number) centerLatitude: number;
	@Type(Number) centerLongitude: number;
	@Type(Number) radius?: number;
}

export class NextOfferQueryFilterType extends NaniumObject<NextOfferQueryFilterType> {
	// NextOfferType value ('ausbildung' | 'studium' | 'fsjbfd')
	@Type(String) offerType?: string;
	// case-insensitive substring match on title OR providerName
	@Type(String) name?: string;
	@Type(NextOfferLocationFilterType) locationFilter?: NextOfferLocationFilterType;
}

export class NextQueryPaginatedRequestBody extends NaniumObject<NextQueryPaginatedRequestBody> {
	@Type(Number) page: number;
	@Type(Number) pageSize: number;
	@Type(NextOfferQueryFilterType) filter?: NextOfferQueryFilterType;
	// distance sort center when no explicit locationFilter center is given
	@Type(GeoLocationType) userLocation?: GeoLocationType;
}

export class NextQueryPaginatedResponse extends NaniumObject<NextQueryPaginatedResponse> {
	@Type(Array, NextOffer) offers: NextOffer[];
	@Type(Number) totalCount: number;
	@Type(Number) pageCount: number;
	@Type(Number) pageSize: number;
	@Type(Number) currentPage: number;
}

@RequestType({
	responseType: NextQueryPaginatedResponse,
	genericTypes: { TRequestBody: NextQueryPaginatedRequestBody },
	scope: 'public',
	skipInterceptors: true
})
export class NextQueryPaginatedRequest extends ServiceRequestBase<NextQueryPaginatedRequestBody, NextQueryPaginatedResponse> {
	static serviceName: string = 'NaniumDemo:next/queryPaginated';
}
